import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCodatIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.39 12.0163L15.2105 16.2699C15.1499 16.3086 15.1499 16.397 15.2105 16.4412L17.5919 18.0763C17.625 18.0984 17.6746 18.0984 17.7076 18.0763L21.5112 15.4578C21.5388 15.4413 21.5553 15.4081 21.5553 15.375V12.1046C21.5553 12.0218 21.4616 11.9721 21.39 12.0163Z",
			fill: "#442FE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.7079 26.7933L26.3621 32.544C26.3345 32.5661 26.318 32.5937 26.318 32.6268V35.8971C26.318 35.98 26.4117 36.0297 26.4779 35.98L34.8237 30.2293C34.8512 30.2072 34.8677 30.1796 34.8677 30.1465V26.8761C34.8677 26.7933 34.7741 26.7436 34.7079 26.7933Z",
			fill: "#442FE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.16 26.5611C30.1931 26.5832 30.2427 26.5832 30.2758 26.5611L32.6516 24.9259C32.7123 24.8873 32.7123 24.7989 32.6516 24.7547L26.4722 20.501C26.4061 20.4513 26.3124 20.501 26.3124 20.5839V23.8542C26.3124 23.8874 26.3289 23.9205 26.3565 23.9371L30.16 26.5611Z",
			fill: "#442FE1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.16 18.3085C13.0938 18.2643 13.0001 18.3085 13.0001 18.3913V21.6672C13.0001 21.7003 13.0167 21.7335 13.0442 21.75L21.39 27.5008C21.4562 27.5505 21.5499 27.5008 21.5499 27.4179V24.1476C21.5499 24.1144 21.5334 24.0813 21.5058 24.0647L13.16 18.3085Z",
			fill: "#442FE1"
		})
	]
});
export default SvgCodatIcon;
